import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { SearchFiltersModule } from '@app/search/components/search-filters/search-filters.module';
import { SearchService } from '@app/search/services/search.service';
import { SharedModule } from '@app/shared/shared.module';
import { OrgManagedContentService } from '../org-managed-notification/org-managed-content.service';
import { AddBySearchBaseComponent } from './add-by-search-base.component';
import { AddBySearchMixedComponent } from './add-by-search-mixed.component';
import { AddBySearchComponent } from './add-by-search.component';

@NgModule({
  declarations: [
    AddBySearchBaseComponent,
    AddBySearchComponent,
    AddBySearchMixedComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,
    SearchFiltersModule,
    ReactiveFormsModule,
  ],
  providers: [SearchService, OrgManagedContentService],
  exports: [AddBySearchComponent, AddBySearchMixedComponent],
})
export class AddBySearchModule {}
